import { Link } from 'react-router-dom'

/**
 * Button — variants: primary | secondary | outline | ghost | danger
 * sizes:    sm | md | lg
 * Classes come from main.css  (.cb-btn, .cb-btn-primary, etc.)
 */
export default function Button({
  children, variant = 'primary', size = 'md',
  icon, iconPos = 'left', href, className = '',
  disabled, loading, onClick, type = 'button', ...rest
}) {
  const classes = `cb-btn cb-btn-${variant} cb-btn-${size} btn-ripple ${className}`.trim()

  // Accept either a bare icon name ("fa-phone" → auto-prefixed "fa-solid fa-phone",
  // kept for backward compatibility) or a full class string ("fa-regular fa-comment",
  // "fa-brands fa-github") for icon styles fa-solid can't represent.
  const iconClass = icon && (icon.includes(' ') ? icon : `fa-solid ${icon}`)

  const content = (
    <>
      {loading  && <i className="fa-solid fa-circle-notch fa-spin" aria-hidden="true" />}
      {!loading && icon && iconPos === 'left'  && <i className={iconClass} aria-hidden="true" />}
      <span>{children}</span>
      {!loading && icon && iconPos === 'right' && <i className={iconClass} aria-hidden="true" />}
    </>
  )

 
if (href) {
  const isExternal =
    href.startsWith('http') ||
    href.startsWith('mailto') ||
    href.startsWith('tel')

  const isAnchor = href.startsWith('#')

  if (isExternal) {
    return (
      <a
        href={href}
        className={classes}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
        {...rest}
      >
        {content}
      </a>
    )
  }

  if (isAnchor) {
    return (
      <a href={href} className={classes} onClick={onClick} {...rest}>
        {content}
      </a>
    )
  }

  return (
    <Link to={href} className={classes} onClick={onClick} {...rest}>
      {content}
    </Link>
  )
}
  return (
    <button type={type} className={classes} disabled={disabled || loading}
      onClick={onClick} aria-disabled={disabled || loading} {...rest}>
      {content}
    </button>
  )
}
